import { SearchCriteria } from 'src/app/core/interfaces/search-criteria.interface';
import { AppInterface } from '../../../interfaces/app.interface';
import { FIELD_PRIORITY_WEIGHT, SEARCH_FIELD, SearchPriorityConfig } from 'src/app/core/interfaces/search-priority-config';

export class AppNameCriteria implements SearchCriteria {
  getMatchScore(_app: AppInterface, _query: string): number {
  
    const name = _app.appName?.toLowerCase() ?? '';
    
    if(name === _query) {
      return 5;
    }
    if(name?.startsWith(_query)) {
      return 3;
    }
    if(name?.includes(_query)) {
      return 1;
    }
    return  0;
  }

  getRelevanceFieldWeightAndMatchScore(_app: AppInterface, _query: string): SearchPriorityConfig {
    return {
      relevanceField: SEARCH_FIELD.OTHER,
      fieldPriorityWeight: FIELD_PRIORITY_WEIGHT.OTHER,
      matchScore: this.getMatchScore(_app, _query)
    }
  }
}
